import { observer } from "mobx-react-lite";

import {
  BaseMinimapSectionItem,
  type MinimapSectionItemProps,
} from "./BaseMinimapSectionItem";

export const FreestyleMinimapSectionItem = observer(
  function FreestyleMinimapSectionItem(props: MinimapSectionItemProps) {
    return <BaseMinimapSectionItem {...props} />;
  },
);
